import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PurchaseOrdersView } from "src/components/views/erp/purchase/purchaseOrders/PurchaseOrdersView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/purchase/purchaseOrders")({
	staticData: { title: i18n.t("purchase_orders"), legacyViewKey: "purchaseOrdersPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <PurchaseOrdersView isActive={isActive} />;
}
